module.exports = __webpack_public_path__ + "static/media/bgpb-small.77e05ef8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bgpb-small.png
// module id = 500
// module chunks = 0